export default __webpack_public_path__ + "static/media/College-Connect-Default-School-Icon.9be914b5.png";